module.exports = __webpack_public_path__ + "img/4.ada8c168.png";